import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=93172e34&"
import script from "./layout.vue?vue&type=script&lang=js&"
export * from "./layout.vue?vue&type=script&lang=js&"
import style0 from "./layout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QLayout,QHeader,QToolbar,QBtn,QToolbarTitle,QDrawer,QList,QItemLabel,QItem,QItemSection,QIcon,QPageContainer,QInnerLoading,QSpinnerGears,QAjaxBar} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QLayout,QHeader,QToolbar,QBtn,QToolbarTitle,QDrawer,QList,QItemLabel,QItem,QItemSection,QIcon,QPageContainer,QInnerLoading,QSpinnerGears,QAjaxBar})
